import { useEffect, useState } from 'react'
import { sfxClick, sfxScore, unlockAudio, unlockAudioSync } from '../gameslib/audio'
import { makePlayers, rankPlayers } from '../gameslib/multiplayer'
import { ROUND_OPTIONS } from './IntroScreen'

export function PlayerSetup({ onConfirm, onBack, rounds = 5, onRounds }) {
  const [count, setCount] = useState(2)
  const [names, setNames] = useState(['', '', '', ''])

  return (
    <div className="mp-setup">
      <h2>Multiplayer</h2>
      <p>Same challenges for everyone. Pass the device after each player finishes.</p>

      <p className="mp-setup__label">Players</p>
      <div className="mp-setup__counts">
        {[2, 3, 4].map((n) => (
          <button
            key={n}
            type="button"
            className={count === n ? 'mp-chip is-active' : 'mp-chip'}
            onClick={() => {
              void sfxClick()
              setCount(n)
            }}
          >
            {n}
          </button>
        ))}
      </div>

      {onRounds && (
        <>
          <p className="mp-setup__label">Rounds per player</p>
          <div className="mp-setup__counts">
            {ROUND_OPTIONS.map((n) => (
              <button
                key={n}
                type="button"
                className={rounds === n ? 'mp-chip is-active' : 'mp-chip'}
                onClick={() => {
                  void sfxClick()
                  onRounds(n)
                }}
              >
                {n}
              </button>
            ))}
          </div>
        </>
      )}

      <div className="mp-setup__names">
        {Array.from({ length: count }, (_, i) => (
          <label key={i}>
            <span>Player {i + 1}</span>
            <input
              type="text"
              maxLength={12}
              placeholder={`Player ${i + 1}`}
              value={names[i]}
              onChange={(e) => {
                const next = [...names]
                next[i] = e.target.value
                setNames(next)
              }}
            />
          </label>
        ))}
      </div>

      <div className="mp-setup__actions">
        <button type="button" className="mp-btn ghost" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          className="mp-btn"
          onClick={() => {
            unlockAudioSync()
            void unlockAudio().then(() => sfxClick())
            onConfirm(makePlayers(count, names))
          }}
        >
          Start
        </button>
      </div>
    </div>
  )
}

export function PassDevice({ player, index, total, rounds = 5, onReady }) {
  return (
    <div className="mp-pass">
      <p className="mp-pass__eyebrow">
        Player {index + 1} of {total}
      </p>
      <h2>Pass to {player.name}</h2>
      <p>
        {rounds} round{rounds === 1 ? '' : 's'} each. Don’t peek at others’ answers.
      </p>
      <button
        type="button"
        className="mp-btn"
        onClick={() => {
          unlockAudioSync()
          void unlockAudio().then(() => sfxClick())
          onReady()
        }}
      >
        I’m {player.name} — start
      </button>
    </div>
  )
}

export function WinnerScreen({ players, onReplay, onHome }) {
  const ranked = rankPlayers(players)
  const winner = ranked[0]

  useEffect(() => {
    if (winner) void sfxScore(winner.avg)
  }, [winner])

  return (
    <div className="mp-winner">
      <p className="mp-winner__eyebrow">Winner</p>
      <h2>{winner?.name || '—'}</h2>
      <p className="mp-winner__score">{winner ? `${winner.avg.toFixed(2)}%` : ''}</p>

      <ol className="mp-winner__list">
        {ranked.map((p, i) => (
          <li key={p.id}>
            <span>
              {i + 1}. {p.name}
            </span>
            <strong>{p.avg.toFixed(2)}%</strong>
          </li>
        ))}
      </ol>

      <div className="mp-setup__actions">
        <button type="button" className="mp-btn ghost" onClick={onHome}>
          Home
        </button>
        <button
          type="button"
          className="mp-btn"
          onClick={() => {
            void sfxClick()
            onReplay()
          }}
        >
          Play again
        </button>
      </div>
    </div>
  )
}
